<div class="asc-notification-bar-message">{{ message }}</div>
<button mat-button (click)="hide()">
   <mat-icon>close</mat-icon>
</button>